import PencilOutline from '@simplywallst/ui-core/icons/PencilOutline';

import { toCurrencyTruncated } from '@/utilities/formatting';
import type { CurrencyISO } from '@/constants/currencies';

type Props = {
  currencyISO: CurrencyISO | null;
  fairValue: number | null;
  onClick: () => void;
};

export const FeedCardMyFairValueSelected = ({
  currencyISO,
  fairValue,
  onClick,
}: Props) => {
  const formattedFairValue = toCurrencyTruncated(
    fairValue || 0,
    2,
    currencyISO ?? 'XXX'
  );

  return (
    <button
      className="group/fv focus-outline grid cursor-pointer grid-cols-[max-content_max-content_auto] items-center gap-x0_5 rounded-md"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick();
      }}
    >
      <span className="text-xs text-softer group-hover/fv:text-soft">
        My Fair Value
      </span>
      <PencilOutline className="size-x2 fill-soft group-hover/fv:fill-solid" />
      <span className="text-xs text-solid">{formattedFairValue}</span>
    </button>
  );
};
